(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trip-inquiry"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    // Same check the relay applies. The browser's type="email" accepts "name@host",
    // which the relay would reject as a 4xx (treated as handled), losing the lead.
    var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function init() {
      var form = document.getElementById('TripInquiryForm');
      if (form) {
        // Validated by hand (validateFields): the relay's stricter email check, and
        // no native validation bubbles before the click handler runs.
        form.noValidate = true;
        setupMonthPicker(form);
        setupReveals(form);
        setupTracking(form);
        setupFormSubmission(form);
      }
      setupScrollButton();
    }

    function emit(name, params) {
      var api = window.tridentBookACall;
      if (api && typeof api.emit === 'function') api.emit(name, params);
    }

    function tripName() {
      return (window.tripBookACall && window.tripBookACall.context) || '';
    }

    // ---- Month picker (assets/trip-month-picker.js) --------------------------------

    var monthPicker = null;

    // The picker asset loads with defer and this code runs from the deferred sections
    // bundle, so either may arrive first.
    function setupMonthPicker(form) {
      var root = form.querySelector('[data-ti-when]');
      if (!root) return;
      function start() {
        monthPicker = window.TridentMonthPicker.init(root, form);
      }
      if (window.TridentMonthPicker) start();
      else document.addEventListener('trident:month-picker-ready', start, { once: true });
    }

    // Writes contact[dates_interested]. Empty if the picker script never loaded.
    function composeDates() {
      if (monthPicker) monthPicker.compose();
    }

    // Reveal links ("+ Add exact dates", "+ Add a note") and clearing error state
    function setupReveals(form) {
      form.addEventListener('input', function(e) {
        if (e.target.getAttribute('aria-invalid') === 'true') {
          e.target.removeAttribute('aria-invalid');
          e.target.setCustomValidity('');
        }
      });

      form.querySelectorAll('[data-trip-reveal]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var panel = document.getElementById(btn.getAttribute('data-trip-reveal'));
          if (!panel) return;
          panel.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          btn.hidden = true;
          var field = panel.querySelector('input, textarea');
          if (field) field.focus();
        });
      });
    }

    // "Jane van Dyke" -> first_name "Jane", last_name "van Dyke"
    function splitName(form) {
      var nameInput = form.querySelector('[data-trip-name]');
      var first = form.querySelector('[data-trip-first-name]');
      var last = form.querySelector('[data-trip-last-name]');
      var full = nameInput ? nameInput.value.trim().replace(/\s+/g, ' ') : '';
      var space = full.indexOf(' ');
      if (first) first.value = space > 0 ? full.slice(0, space) : full;
      if (last) last.value = space > 0 ? full.slice(space + 1) : '';
    }

    // Checks the visible required fields; reports the first problem.
    function validateFields(form) {
      var fields = form.querySelectorAll('input, textarea');
      // The month picker comes first on screen, so it is checked first.
      if (monthPicker && !monthPicker.validate()) return false;

      for (var i = 0; i < fields.length; i++) {
        var field = fields[i];
        if (field.type === 'hidden' || field.closest('[hidden]') || field.closest('[aria-hidden="true"]')) continue;

        field.setCustomValidity('');
        if (field.type === 'email' && field.value.trim() && !EMAIL_PATTERN.test(field.value.trim())) {
          field.setCustomValidity('Please enter a full email address, like name@example.com.');
        }
        if (field.required && !field.value.trim()) {
          field.setCustomValidity('Please fill in this field.');
        }
        if (!field.checkValidity()) {
          field.setAttribute('aria-invalid', 'true');
          field.focus();
          field.reportValidity();
          return false;
        }
      }
      return true;
    }

    // ---- Funnel tracking -------------------------------------------------------------

    // The funnel (start once, abandon at most once after a start and before a
    // submit, submit once) lives in assets/book-a-call.js (trackForm). That script
    // is deferred and runs after this sections bundle, so calls made before it has
    // run are replayed once it has; the Shopify-fallback success message rendered
    // on load is counted that way.
    var tracker = null;
    var pendingFunnelCalls = [];

    function funnel(method, arg) {
      if (tracker) {
        tracker[method](arg);
        return;
      }
      pendingFunnelCalls.push([method, arg]);
    }

    function setupTracking(form) {
      function attach() {
        var api = window.tridentBookACall;
        if (tracker || !api || typeof api.trackForm !== 'function') return;
        tracker = api.trackForm(form, function () {
          return { form_id: 'trip_inquiry_form', form_location: 'trip_page', trip: tripName(), inquiry_type: '' };
        });
        pendingFunnelCalls.forEach(function (call) { tracker[call[0]](call[1]); });
        pendingFunnelCalls = [];
      }
      attach();
      if (!tracker) document.addEventListener('trident:book-a-call:ready', attach, { once: true });

      var callBtn = form.querySelector('[data-book-call-trigger]');
      if (callBtn) {
        callBtn.addEventListener('click', function() { funnel('leftFor', 'book_a_call'); });
      }
    }

    // ---- Submission ------------------------------------------------------------------

    function setupFormSubmission(form) {
      var submitBtn = document.getElementById('submit-btn');
      var btnText = submitBtn && submitBtn.querySelector('.trip-btn-text');
      var btnSpinner = submitBtn && submitBtn.querySelector('.trip-btn-spinner');
      var statusMessages = document.getElementById('form-status-messages');

      // Shopify fallback path: the page came back with the success message already
      // rendered, so showSuccess() never runs and has to be caught here instead.
      if (statusMessages && statusMessages.querySelector('.form-message--success')) {
        funnel('submitted');
        collapseToConfirmation();
        appendBookACallStep(statusMessages);
      }

      function resetButton() {
        submitBtn.disabled = false;
        btnText.style.display = '';
        btnSpinner.style.display = 'none';
      }

      function showSuccess() {
        resetButton();
        statusMessages.innerHTML = '<div class="form-message form-message--success">' + window.tripInquirySuccessMessage + '</div>';
        form.reset();
        // travel_inquiry_submit + generate_lead, once per page view
        funnel('submitted');
        collapseToConfirmation();
        appendBookACallStep(statusMessages);
        statusMessages.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      // The confirmation becomes the whole panel: fields, heading and the "fill out
      // the form below" line go, so nothing points at a form that is no longer there
      // or invites a duplicate submission.
      function collapseToConfirmation() {
        var flow = form.querySelector('[data-trip-flow]');
        if (flow) flow.style.display = 'none';
        ['.trip-inquiry__title', '.trip-inquiry__description'].forEach(function (sel) {
          var el = document.querySelector(sel);
          if (el) el.style.display = 'none';
        });
      }

      // The lead is already delivered by the time this runs, so offering a time here
      // is free upside: it replaces "we'll be in touch" with a slot on the calendar.
      function appendBookACallStep(container) {
        var cfg = window.tripBookACall || {};
        if (!cfg.afterInquiry || !cfg.url) return;

        var wrap = document.createElement('div');
        wrap.className = 'trip-inquiry__post-success';

        var text = document.createElement('p');
        text.textContent = 'Would you rather talk it through? Pick a time and a travel specialist will call you.';
        wrap.appendChild(text);

        var button = document.createElement('a');
        button.className = 'book-call-button';
        button.href = cfg.url;
        button.target = '_blank';
        button.rel = 'noopener';
        button.textContent = cfg.label || 'Book a Call';
        button.setAttribute('data-book-call-trigger', '');
        button.setAttribute('data-book-call-source', 'trip_inquiry_confirmation');
        if (cfg.context) button.setAttribute('data-book-call-context', cfg.context);

        wrap.appendChild(button);
        container.appendChild(wrap);
      }

      function showError() {
        resetButton();
        statusMessages.innerHTML = '<div class="form-message form-message--error">There was an error submitting your form. Please try again.</div>';
        statusMessages.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      // Fallback path only. Travel inquiries normally never reach Shopify, because
      // Shopify emails support@ and every one of those becomes a Gorgias ticket.
      // This runs solely when the travel relay is unreachable, so that a lead still
      // lands somewhere rather than being lost.
      function submitToShopify() {
        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: {
            'Accept': 'text/html'
          }
        })
        .then(function (response) {
          // Shopify bot protection returns 400 and requires a captcha challenge.
          // Hand the form to the browser: requestSubmit dispatches submit, so the
          // bot-protection script runs its challenge and posts the form itself.
          if (response.status === 400 || response.url.includes('/challenge')) {
            resetButton();
            if (typeof form.requestSubmit === 'function') form.requestSubmit();
            else form.submit();
            return;
          }

          if (!response.ok) {
            return response.text().then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var errorMessage = doc.querySelector('.form-message--error');

              resetButton();
              statusMessages.innerHTML = errorMessage
                ? errorMessage.outerHTML
                : '<div class="form-message form-message--error">There was an error submitting your form. Please try again.</div>';
              statusMessages.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            });
          }

          // Any OK response (including followed redirects) = success
          showSuccess();
        })
        .catch(showError);
      }

      // Everything happens on the click, and the click is cancelled, so no submit
      // event is ever dispatched. Shopify's storefront bot-protection script
      // (ce_storefront_forms_captcha) listens for submit on every Shopify contact form
      // and, about a second later, posts the form natively to /contact itself. With
      // the relay already delivered that meant a second copy of every inquiry at
      // support@ (a Gorgias ticket) and a reload that counted the submission again.
      // Enter in a field clicks this button too (implicit submission), so it takes
      // this path as well.
      submitBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (submitBtn.disabled) return;
        if (!validateFields(form)) return;

        splitName(form);
        composeDates(form);

        // Show loading state
        submitBtn.disabled = true;
        btnText.style.display = 'none';
        btnSpinner.style.display = 'inline-block';

        // Relay first: this delivers straight to travel@ and keeps the inquiry out
        // of the support queue entirely.
        var relay = window.tridentSubmitTravelInquiry
          ? window.tridentSubmitTravelInquiry(form)
          : Promise.resolve(false);

        relay.then(function (relayed) {
          if (relayed) {
            showSuccess();
            return;
          }
          submitToShopify();
        });
      });

      // Exposed for QA: the fields a submit would send, without sending them.
      form.tridentPrepare = function() {
        splitName(form);
        composeDates(form);
      };
    }

    function setupScrollButton() {
      var scrollBtn = document.getElementById('scroll-cue-btn');
      var inquirySection = document.querySelector('.trip-inquiry');
      if (!scrollBtn || !inquirySection) return;

      // Show while the inquiry section is on screen; hide once it has scrolled
      // 30% of the way up (into the next section).
      function updateScrollButton() {
        var rect = inquirySection.getBoundingClientRect();
        var fadeThreshold = window.innerHeight * 0.7;
        if (rect.top < window.innerHeight && rect.bottom > fadeThreshold) {
          scrollBtn.classList.add('visible');
        } else {
          scrollBtn.classList.remove('visible');
        }
      }

      window.addEventListener('scroll', updateScrollButton);
      updateScrollButton();

      scrollBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var sectionBottom = inquirySection.getBoundingClientRect().bottom + window.pageYOffset;
        window.scrollTo({ top: sectionBottom, behavior: 'smooth' });
      });
    }

    // Start last: every var above (picker state, constants) must be assigned first.
    // This file runs from Shopify's deferred sections bundle, i.e. usually after the
    // document has parsed, so init() would otherwise run before those assignments.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
